import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { cacheDom } from "../../utils/QuerySelectors.js"
import { setOpen, setCountry } from '../store/addressSlice'

const dom = {}
const qs = {
  list: 'data-addresses-list',
  add: 'data-address-add',
  countryOptions: 'data-country-options',
}
const qsAll = {
}

const AddressForm = () => {
  const dispatch = useDispatch()
  const { address, open } = useSelector((state) => state.address)
  cacheDom(dom, qs, qsAll)
  dom.list.classList.toggle('hidden', open)
  dom.add.classList.toggle('hidden', open)
  console.log(address)

  return (
    <form className={`block w-full max-w-[42rem] bg-back ${open ? '' : 'hidden'}`} method='post' action={`/account/addresses${address && address.id ? '/' +  address.id : ''}`} acceptCharset='UTF-8'>
      <input type="hidden" name="form_type" value="customer_address" />
      <input type="hidden" name="utf8" value="✓" />
      <div className='grid grid-cols-2 gap-3 lg:gap-4 mb-3 lg:mb-4'>
        <div className="input-wrap">
          <input
            type="text"
            id="AddressFirstName"
            name="address[first_name]"
            defaultValue={address && address.first_name}
            autoComplete="given-name"
            placeholder="First Name *"
            required
          />
          <label htmlFor="AddressFirstName">First Name *</label>
        </div>
        <div className="input-wrap">
          <input
            type="text"
            id="AddressLastName"
            name="address[last_name]"
            defaultValue={address && address.last_name}
            autoComplete="family-name"
            placeholder="Last Name *"
            required
          />
          <label htmlFor="AddressLastName">Last Name *</label>
        </div>
      </div>
      <div className='select-wrap mb-3 lg:mb-4'>
        <label className='mb-3 block' htmlFor="AddressCountry">Country / Region *</label>
        <select
          id="AddressCountry"
          name="address[country]"
          autoComplete="country"
          required
          value={address?.country}
          onChange={(e) => dispatch(setCountry(e.target.value))}
          dangerouslySetInnerHTML={{ __html: dom.countryOptions.innerHTML}}
        >
        </select>
      </div>
      <div className="input-wrap mb-3 lg:mb-4">
        <input
          type="text"
          id="AddressAddress1"
          name="address[address1]"
          defaultValue={address && address.address1}
          autoComplete="address-line1"
          placeholder="Address Line 1 *"
          required
        />
        <label htmlFor="AddressAddress1">Address Line 1 *</label>
      </div>
      <div className="input-wrap mb-3 lg:mb-4">
        <input
          type="text"
          id="AddressAddress2"
          name="address[address2]"
          defaultValue={address && address.address2}
          autoComplete="address-line2"
          placeholder="Address Line 2"
        />
        <label htmlFor="AddressAddress2">Address Line 2</label>
      </div>
      <div className={`grid gap-3 lg:gap-4 mb-3 lg:mb-4 ${address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).length > 0 ? 'grid-cols-2' : 'grid-cols-1'}`}>
        <div className="input-wrap">
          <input
            type="text"
            id="AddressCity"
            name="address[city]"
            defaultValue={address && address.city}
            autoComplete="address-level2"
            placeholder="City *"
            required
          />
          <label htmlFor="AddressCity">City *</label>
        </div>
        {
          address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).length > 0 &&
          <div className='select-wrap'>
            <label className='mb-3 block' htmlFor="AddressProvince">State *</label>
            <select
              id="AddressProvince"
              name="address[province]"
              defaultValue={address?.province}
              autoComplete="address-level1"
              required
            >
              {
                address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).map((province, index) =>
                  <option value={province[1]} key={`province-${index}`}>{province[0]}</option>
                )
              }
            </select>
          </div>
        }
      </div>
      <div className='grid grid-cols-2 gap-3 lg:gap-4 mb-3 lg:mb-4'>
        <div className="input-wrap">
          <input
            type="text"
            id="AddressZip"
            name="address[zip]"
            defaultValue={address && address.zip}
            autoCapitalize="characters"
            autoComplete="postal-code"
            placeholder="Zip Code *"
            required
          />
          <label htmlFor="AddressZip">Zip Code *</label>
        </div>
        <div className="input-wrap">
          <input
            type="tel"
            id="AddressPhone"
            name="address[phone]"
            defaultValue={address && address.phone}
            autoComplete="tel"
            placeholder="Phone Number *"
            required
          />
          <label htmlFor="AddressPhone">Phone Number *</label>
        </div>
      </div>
      <label
        htmlFor="address_default"
        className="checkbox-wrapper w-full"
      >
        <input type="checkbox" id="address_default" name="address[default]" value="1" defaultChecked={address && address.default == true} />
        <span className="checkbox-text justify-center">Set as Default Address</span>
      </label> 
      <button className='button buttom--primary !bg-yellow !border-yellow !text-grey hover:!text-black w-full mt-12 lg:mt-[3.5rem] mb-4'>
        { address && address.id ? 'Save address' : 'Register' }
      </button>
      <div className='text-center'>
        <button type="reset" className='focus-link' onClick={() => dispatch(setOpen(false))}>Cancel</button>
      </div>
      { address && address.id ? <input type="hidden" name="_method" value="put" /> : null }
    </form>
  )
}

export default AddressForm